export enum BankOperationSingleTypes {
  Manual = 'manual',
  Percentage = 'percentage',
  Losses = 'losses',
}

export enum BankOperationRelatedTypes {
  Transfer = 'transfer',
  Conversion = 'conversion',
  ConversionReferrals = 'conversion_referrals',
}

export type BankOperationValue = BankOperationSingleTypes | BankOperationRelatedTypes;

export const BankOperationSingleTypesChoices = [
  BankOperationSingleTypes.Manual,
  BankOperationSingleTypes.Percentage,
  BankOperationSingleTypes.Losses,
  BankOperationRelatedTypes.Transfer,
];

export const BankOperationRelatedTypesChoices = [
  BankOperationRelatedTypes.Transfer,
  BankOperationRelatedTypes.Conversion,
  BankOperationRelatedTypes.ConversionReferrals,
];

export const BankOperationAllTypesChoices = Array.from(
  new Set([...BankOperationSingleTypesChoices, ...BankOperationRelatedTypesChoices]),
);
